import "./ReportedPostsSummary.css";
import { Card, CardTitle } from "../../common";
import { useAppState } from "../../../utils/appState";
import ReportedPostsBrowser from "../ReportedPostsBrowser";

export default function ReportedPostsSummary({ count }) {
  const [, setAppState] = useAppState();
  return (
    <Card className="dashboard-report">
      <CardTitle title={"REPORTED POSTS"} />
      <div className="dashboard-report__body">
        <div className="dashboard-report__body__blurb">
          There are <span className="bold">{count}</span> reported posts pending
          review.
        </div>

        {!!count && (
          <div
            className="dashboard-report__body__link"
            onClick={() => {
              setAppState({ modal: <ReportedPostsBrowser /> });
            }}
          >
            View reported posts
          </div>
        )}
      </div>
    </Card>
  );
}
